export default class User {
    constructor(json) {
        this.id = json.id;
        this.login = json.login;
        this.admin = !!json.admin;
        this.settings = json.settings||{};
    }
}